import axios from "axios";
/**
 * 实时天气
 * 根据地区的LocationID或以英文逗号分隔的经度,纬度坐标获取实时天气
 * @param {string} location 地区的LocationID或以英文逗号分隔的经度,纬度坐标（例如 location=101010100 或 location=116.41,39.92)
 */
export function getNowWeather(location) {
  return axios
    .get(
      `https://devapi.qweather.com/v7/weather/now?location=${location}&key=1947339eaa4a4beaa0d78650ebf4d12c`,
      {
        headers: {
          "X-QW-Api-Key": "1947339eaa4a4beaa0d78650ebf4d12c",
        },
      }
    )
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
/**
 * 逐小时天气预报
 * 根据预报小时数获取逐小时天气预报
 * @param {string} hours 小时数
 */
export function getHourWeather(query) {
  return axios
    .get(
      `https://devapi.qweather.com/v7/weather/${query.hours}?location=${query.location}&key=1947339eaa4a4beaa0d78650ebf4d12c`,
      {
        headers: {
          "X-QW-Api-Key": "1947339eaa4a4beaa0d78650ebf4d12c",
        },
      }
    )
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
/**
 * 灾害预警
 * 根据地区的LocationID或以英文逗号分隔的经度,纬度坐标获取天气灾害预警
 * @param {string} location 地区的LocationID或以英文逗号分隔的经度,纬度坐标（例如 location=101010100 或 location=116.41,39.92)
 */
export function getNowWarning(location) {
  return axios
    .get(
      `https://devapi.qweather.com/v7/warning/now?location=${location}&key=1947339eaa4a4beaa0d78650ebf4d12c`,
      {
        headers: {
          "X-QW-Api-Key": "8406b69e62274dbb91ab5ec9064fcb3d",
        },
      }
    )
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}